import { createRoute } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// El portal de padres se movió a "/padres" (ver padres.tsx) para liberar "/kidstenia" para
// una futura página pública. Este shim solo existe para que un link "/kidstenia?t=..." ya
// compartido con algún padre antes del cambio siga funcionando — redirige preservando el
// token de la URL.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/kidstenia",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: KidsteniaRedirect,
});

function KidsteniaRedirect() {
  if (typeof window !== "undefined") {
    window.location.replace(`/padres${window.location.search}`);
  }
  return null;
}
